<template>
<transition name="fade-in">
<aside v-if="appState != 'closed'" :class="appState" class="mobile-menu fixed left-0 top-0 w-full h-full bg-white z-50 flex items-center">
    <button @click="close" class="closer text-secondary-500 absolute transition-colors">
        <i class="fas fa-times text-4xl" aria-hidden="true"></i>
        <span class="sr-only">Close Mobile Menu</span>
    </button>
    <nav class="w-full">
        <ul class="mx-auto">
            <li class="block text-center my-2" v-for="(link, i) in mainMenu" :class="{'in': stagger >= i + 1}">
                <Link class="text-secondary-600 text-3xl" :pre-load="smoothClose" :href="link.href">
                    {{ link.name }}
                </Link>
            </li>
        </ul>
    </nav>
    <div v-if="headerButtons.length" class="fixed bottom-0 left-0 w-full flex justify-center pb-4">
        <div v-for="button in headerButtons">
            <Button :url="button.href" :pre-load="smoothClose" :label="button.name" variant="button-splat"></Button>
        </div>
    </div>
</aside>
</transition>
</template>

<script>
import { ref, computed, onMounted, nextTick } from 'vue';
export default {
    props: ['mainMenu', 'headerButtons'],
    setup(props) {

        const appState = ref('closed');
        const stagger = ref(0);

        const open = async (e) => {
            appState.value = 'start-open';
            await nextTick();
            appState.value = 'opening';
            await window.wait(100);

            let loop = window.setInterval(() => {
                if (stagger.value > props.mainMenu.length) {
                    window.clearInterval(loop);
                    return;
                }
                stagger.value = stagger.value + 1;
            }, 100);

        };

        const smoothClose = async () => {
            return new Promise((resolve) => {
                close();
                window.wait(300).then(resolve);
            });
        };

        const close = () => {
            appState.value = 'closed';
            stagger.value = 0;
        };

        onMounted(() => {
            window.addEventListener('openMobileMenu', open);
        });

        return {
            appState,
            close,
            smoothClose,
            stagger
        };
    }
}
</script>